<div class="contacts-form-wrapper">
  <div class="contacts-form-scroll-content">
    <dx-validation-group #societyValidationGroup>
      <div class="gpd-form-grid">
        <!-- Main column: what the Gesellschaft is. -->
        <div class="gpd-form-column">
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="building" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societyMasterData">Master Data</span>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@societyLegalName">Full legal name</label>
                <dx-text-box class="gpd-input" [(value)]="formData.legalName" i18n-placeholder="@@societyLegalNamePlaceholder" placeholder="e.g. Solarpark Musterstadt GmbH & Co. KG">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@societyLegalForm">Legal form</label>
                <dx-select-box class="gpd-input" [items]="legalForms" displayExpr="text" valueExpr="key" [(value)]="formData.legalForm" i18n-placeholder="@@pleaseSelect" placeholder="Please Select">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@societyStatus">Company status</label>
                <dx-select-box class="gpd-input" [items]="societyStates" displayExpr="text" valueExpr="key" [(value)]="formData.status" i18n-placeholder="@@pleaseSelect" placeholder="Please Select">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyTransactionType">Transaction type</label>
                <dx-select-box class="gpd-input" [items]="transactionTypes" displayExpr="text" valueExpr="key" [(value)]="formData.transactionType" i18n-placeholder="@@pleaseSelect" placeholder="Please Select"></dx-select-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyFoundingDate">Founding date</label>
                <dx-date-box class="gpd-input" type="date" displayFormat="dd.MM.yyyy" [(value)]="formData.foundingDate" i18n-placeholder="@@societyDatePlaceholder" placeholder="DD.MM.YYYY"></dx-date-box>
              </div>
            </div>

            <!-- Values from Admin ▸ Gesellschaften; the org chart groups the Gesellschaften by it. -->
            <div class="gpd-form-row gpd-form-row--half">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societySalesModel">Portfolio assignment</label>
                <dx-select-box
                  class="gpd-input"
                  [items]="salesModels"
                  displayExpr="name"
                  valueExpr="id"
                  [(value)]="formData.salesModelId"
                  [showClearButton]="true"
                  i18n-placeholder="@@pleaseSelect"
                  placeholder="Please Select"
                ></dx-select-box>
              </div>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyPurpose">Company purpose</label>
                <dx-text-area class="gpd-input society-text-area" [(value)]="formData.purpose" [autoResizeEnabled]="true" [minHeight]="80" i18n-placeholder="@@societyPurposePlaceholder" placeholder="Object of the company as stated in the articles of association"></dx-text-area>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="location" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societySeatAndAddress">Seat & Address</span>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@societyRegisteredSeat">Registered seat</label>
                <dx-text-box class="gpd-input" [(value)]="formData.registeredSeatAddress" i18n-placeholder="@@addressPlaceholder" placeholder="e.g. Main Street 1">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@zipcode">Zipcode</label>
                <dx-text-box class="gpd-input" [(value)]="formData.registeredSeatZipcode" [maxLength]="10" i18n-placeholder="@@zipcodePlaceholder" placeholder="e.g. 12345">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@city">City</label>
                <dx-text-box class="gpd-input" [(value)]="formData.registeredSeat" i18n-placeholder="@@cityPlaceholder" placeholder="e.g. Berlin">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>

            <div class="gpd-form-row gpd-form-row--half">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@country">Country</label>
                <dx-select-box
                  class="gpd-input"
                  [(value)]="formData.registeredSeatCountryId"
                  [dataSource]="countries"
                  displayExpr="countryName"
                  valueExpr="countryId"
                  i18n-placeholder="@@pleaseSelect"
                  placeholder="Please Select"
                >
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>

            <!-- Usually the business address is the registered seat; only a different one is entered. -->
            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <app-gpd-checkbox
                  [(value)]="formData.businessAddressDiffers"
                  i18n-label="@@societyBusinessAddressDiffers"
                  label="Business address differs from registered seat"
                ></app-gpd-checkbox>
              </div>
            </div>

            @if (formData.businessAddressDiffers) {
              <div class="gpd-form-row">
                <div class="gpd-form-field">
                  <label class="gpd-form-label gpd-form-required" i18n="@@societyBusinessAddress">Business address</label>
                  <dx-text-box class="gpd-input" [(value)]="formData.address" i18n-placeholder="@@addressPlaceholder" placeholder="e.g. Main Street 1">
                    <dx-validator>
                      <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>

              <div class="gpd-form-row">
                <div class="gpd-form-field">
                  <label class="gpd-form-label gpd-form-required" i18n="@@zipcode">Zipcode</label>
                  <dx-text-box class="gpd-input" [(value)]="formData.zipcode" [maxLength]="10" i18n-placeholder="@@zipcodePlaceholder" placeholder="e.g. 12345">
                    <dx-validator>
                      <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
                <div class="gpd-form-field">
                  <label class="gpd-form-label gpd-form-required" i18n="@@city">City</label>
                  <dx-text-box class="gpd-input" [(value)]="formData.city" i18n-placeholder="@@cityPlaceholder" placeholder="e.g. Berlin">
                    <dx-validator>
                      <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>

              <div class="gpd-form-row gpd-form-row--half">
                <div class="gpd-form-field">
                  <label class="gpd-form-label gpd-form-required" i18n="@@country">Country</label>
                  <dx-select-box
                    class="gpd-input"
                    [(value)]="formData.countryId"
                    [dataSource]="countries"
                    displayExpr="countryName"
                    valueExpr="countryId"
                    i18n-placeholder="@@pleaseSelect"
                    placeholder="Please Select"
                  >
                    <dx-validator>
                      <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </div>
              </div>
            }
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="license-draft" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societyCommercialRegister">Commercial Register</span>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyRegisterCourt">Register court</label>
                <dx-text-box class="gpd-input" [(value)]="formData.registerCourt" i18n-placeholder="@@societyRegisterCourtPlaceholder" placeholder="e.g. Amtsgericht Charlottenburg"></dx-text-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyRegisterNumber">Commercial register number</label>
                <dx-text-box class="gpd-input" [(value)]="formData.registerNumber" i18n-placeholder="@@societyRegisterNumberPlaceholder" placeholder="e.g. HRB 12345"></dx-text-box>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="coins-euro" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societyOwnershipAndCapital">Ownership & Capital</span>
            </div>

            <!-- Stammkapital (GmbH, UG) / Grundkapital (AG); a KG has none, its Kommanditisten a Hafteinlage each. -->
            @if (!hasPartnerRoles) {
            <div class="gpd-form-row gpd-form-row--half">
              <div class="gpd-form-field">
                <label class="gpd-form-label" [class.gpd-form-required]="capitalRequired">{{ capitalLabel }}</label>
                <dx-number-box class="gpd-input" [(value)]="formData.shareCapital" [min]="0" format="#,##0.00 €" i18n-placeholder="@@societyShareCapitalPlaceholder" placeholder="e.g. 25.000,00 €">
                  <dx-validator *ngIf="capitalRequired">
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </div>
            }

            <div class="society-shareholders">
              <div class="society-shareholder-row" *ngFor="let shareholder of formData.shareholders; let i = index">
                <div class="gpd-form-field society-shareholder-contact">
                  <label class="gpd-form-label" *ngIf="i === 0" i18n="@@societyShareholder">Shareholder</label>
                  <div class="society-contact-pick">
                    <app-contacts-dropdown-box
                      class="society-contact-pick-box"
                      [(contactId)]="shareholder.contactId"
                      [(contactType)]="shareholder.contactType"
                      [companies]="companies"
                      [persons]="persons"
                      [validationRequired]="false"
                      [excludeSocietyId]="societyId || null"
                      (onContactSelected)="onContactSelected($event, shareholder)"
                      (onNewContactRequested)="onNewContactFromDropdown($event, shareholder)"
                    ></app-contacts-dropdown-box>
                    <app-gpd-button
                      *ngIf="shareholder.contactId"
                      type="text"
                      icon="user"
                      i18n-hint="@@societyOpenContact"
                      hint="Open contact"
                      (onClick)="openContact(shareholder)"
                    ></app-gpd-button>
                  </div>
                </div>
                <div class="gpd-form-field society-shareholder-role" *ngIf="hasPartnerRoles">
                  <label class="gpd-form-label" *ngIf="i === 0" i18n="@@societyShareholderRole">Role</label>
                  <dx-select-box
                    class="gpd-input"
                    [items]="shareholderRoles"
                    displayExpr="text"
                    valueExpr="key"
                    [(value)]="shareholder.role"
                    [showClearButton]="true"
                    placeholder="–"
                  ></dx-select-box>
                </div>
                <div class="gpd-form-field society-shareholder-share">
                  <label class="gpd-form-label gpd-form-required" *ngIf="i === 0" i18n="@@societyShareQuota">Share</label>
                  <dx-number-box class="gpd-input" [(value)]="shareholder.share" [min]="0" [max]="100" format="#0.## '%'" valueChangeEvent="input" placeholder="0 %">
                    <!-- Once a shareholder is picked; a Komplementär usually holds no capital. -->
                    <dx-validator *ngIf="shareholder.contactId && shareholder.role !== 'general_partner'">
                      <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-number-box>
                </div>
                <div class="gpd-form-field society-shareholder-liability" *ngIf="hasPartnerRoles">
                  <label class="gpd-form-label" *ngIf="i === 0" i18n="@@societyLiabilityAmount">Liability amount</label>
                  <!-- Only a Kommanditist has a Hafteinlage (the sum in the commercial register);
                       for the others the field stays, disabled, so the row keeps its columns. -->
                  <dx-number-box
                    class="gpd-input"
                    [disabled]="shareholder.role !== 'limited_partner'"
                    i18n-hint="@@societyLiabilityAmountHint"
                    hint="Only for a limited partner"
                    [(value)]="shareholder.liabilityAmount"
                    [min]="0"
                    format="#,##0.00 €"
                    valueChangeEvent="input"
                    placeholder="0,00 €"
                  ></dx-number-box>
                </div>
                <app-gpd-button
                  class="society-row-remove"
                  [class.society-row-remove--first]="i === 0"
                  type="text"
                  icon="delete"
                  iconColor="var(--color-red-500)"
                  [ngClass]="{ 'gpd-button-text-danger': true }"
                  i18n-hint="@@societyRemoveShareholder"
                  hint="Remove shareholder"
                  (onClick)="removeShareholder(i)"
                ></app-gpd-button>
              </div>

              <div class="society-shareholder-footer">
                <app-gpd-button type="text" icon="add" i18n-text="@@societyAddShareholder" text="Add shareholder" (onClick)="addShareholder()"></app-gpd-button>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="user-multiple" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societyRepresentation">Representation</span>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@societyManagingDirectors">Authorized representatives</label>
                <!-- Same contacts dropdown as the shareholders, one row per person or company, each with its function. -->
                <div class="society-shareholders">
                  <div class="society-shareholder-row society-director-row" *ngFor="let director of formData.managingDirectors; let i = index">
                    <div class="society-contact-pick society-shareholder-contact">
                      <app-contacts-dropdown-box
                        class="society-contact-pick-box"
                        [(contactId)]="director.contactId"
                        [(contactType)]="director.contactType"
                        [companies]="companies"
                        [persons]="persons"
                        [validationRequired]="i === 0"
                        [validationMessage]="managingDirectorRequired"
                        (onContactSelected)="onContactSelected($event, director)"
                        (onNewContactRequested)="onNewContactFromDropdown($event, director)"
                      ></app-contacts-dropdown-box>
                      <app-gpd-button
                        *ngIf="director.contactId"
                        type="text"
                        icon="user"
                        i18n-hint="@@societyOpenContact"
                        hint="Open contact"
                        (onClick)="openContact(director)"
                      ></app-gpd-button>
                    </div>
                    <dx-select-box
                      class="gpd-input society-director-function"
                      [items]="representativeFunctions"
                      displayExpr="text"
                      valueExpr="key"
                      [(value)]="director.function"
                      i18n-hint="@@societyFunction"
                      hint="Function"
                    ></dx-select-box>
                    <app-gpd-button
                      class="society-row-remove"
                      type="text"
                      icon="delete"
                      iconColor="var(--color-red-500)"
                      [ngClass]="{ 'gpd-button-text-danger': true }"
                      i18n-hint="@@societyRemoveManagingDirector"
                      hint="Remove"
                      (onClick)="removeManagingDirector(i)"
                    ></app-gpd-button>
                  </div>
                  <div class="society-shareholder-footer">
                    <app-gpd-button type="text" icon="add" i18n-text="@@societyAddManagingDirector" text="Add representative" (onClick)="addManagingDirector()"></app-gpd-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="gpd-form-row gpd-form-row--half">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required" i18n="@@societyRepresentationRule">Power of representation</label>
                <dx-select-box class="gpd-input" [items]="representationRules" displayExpr="text" valueExpr="key" [(value)]="formData.representationRule" i18n-placeholder="@@pleaseSelect" placeholder="Please Select">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="receipt-euro" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societyTax">Tax & accounting</span>
            </div>

            <div class="gpd-form-row gpd-form-row--half">
              <!-- On a purchase the previous tax advisor is asked for as well, next to it. -->
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyResponsibleTaxAdvisor">Responsible tax advisor</label>
                <div class="society-contact-pick">
                  <app-contacts-dropdown-box
                    class="society-contact-pick-box"
                    [(contactId)]="formData.taxAdvisor.contactId"
                    [(contactType)]="formData.taxAdvisor.contactType"
                    [companies]="companies"
                    [persons]="persons"
                    [validationRequired]="false"
                    (onContactSelected)="onContactSelected($event, formData.taxAdvisor)"
                    (onNewContactRequested)="onNewContactFromDropdown($event, formData.taxAdvisor)"
                  ></app-contacts-dropdown-box>
                  <app-gpd-button
                    *ngIf="formData.taxAdvisor.contactId"
                    type="text"
                    icon="user"
                    i18n-hint="@@societyOpenContact"
                    hint="Open contact"
                    (onClick)="openContact(formData.taxAdvisor)"
                  ></app-gpd-button>
                </div>
              </div>
              <div class="gpd-form-field" *ngIf="isPurchase">
                <label class="gpd-form-label" i18n="@@societyPreviousTaxAdvisor">Previous tax advisor</label>
                <div class="society-contact-pick">
                  <app-contacts-dropdown-box
                    class="society-contact-pick-box"
                    [(contactId)]="formData.previousTaxAdvisor.contactId"
                    [(contactType)]="formData.previousTaxAdvisor.contactType"
                    [companies]="companies"
                    [persons]="persons"
                    [validationRequired]="false"
                    (onContactSelected)="onContactSelected($event, formData.previousTaxAdvisor)"
                    (onNewContactRequested)="onNewContactFromDropdown($event, formData.previousTaxAdvisor)"
                  ></app-contacts-dropdown-box>
                  <app-gpd-button
                    *ngIf="formData.previousTaxAdvisor.contactId"
                    type="text"
                    icon="user"
                    i18n-hint="@@societyOpenContact"
                    hint="Open contact"
                    (onClick)="openContact(formData.previousTaxAdvisor)"
                  ></app-gpd-button>
                </div>
              </div>
            </div>

            <!-- Buchhaltung: who keeps the books and who stands in; both optional. -->
            <div class="gpd-form-row gpd-form-row--half">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyAccountant">Responsible accountant</label>
                <div class="society-contact-pick">
                  <app-contacts-dropdown-box
                    class="society-contact-pick-box"
                    [(contactId)]="formData.accountant.contactId"
                    [(contactType)]="formData.accountant.contactType"
                    [companies]="companies"
                    [persons]="persons"
                    [validationRequired]="false"
                    (onContactSelected)="onContactSelected($event, formData.accountant)"
                    (onNewContactRequested)="onNewContactFromDropdown($event, formData.accountant)"
                  ></app-contacts-dropdown-box>
                  <app-gpd-button
                    *ngIf="formData.accountant.contactId"
                    type="text"
                    icon="user"
                    i18n-hint="@@societyOpenContact"
                    hint="Open contact"
                    (onClick)="openContact(formData.accountant)"
                  ></app-gpd-button>
                </div>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyAccountantDeputy">Deputy accountant</label>
                <div class="society-contact-pick">
                  <app-contacts-dropdown-box
                    class="society-contact-pick-box"
                    [(contactId)]="formData.accountantDeputy.contactId"
                    [(contactType)]="formData.accountantDeputy.contactType"
                    [companies]="companies"
                    [persons]="persons"
                    [validationRequired]="false"
                    (onContactSelected)="onContactSelected($event, formData.accountantDeputy)"
                    (onNewContactRequested)="onNewContactFromDropdown($event, formData.accountantDeputy)"
                  ></app-contacts-dropdown-box>
                  <app-gpd-button
                    *ngIf="formData.accountantDeputy.contactId"
                    type="text"
                    icon="user"
                    i18n-hint="@@societyOpenContact"
                    hint="Open contact"
                    (onClick)="openContact(formData.accountantDeputy)"
                  ></app-gpd-button>
                </div>
              </div>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyTaxNumber">Tax number</label>
                <dx-text-box class="gpd-input" [(value)]="formData.taxNumber" i18n-placeholder="@@societyTaxNumberPlaceholder" placeholder="e.g. 12/345/67890"></dx-text-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@societyVatId">VAT ID</label>
                <dx-text-box class="gpd-input" [(value)]="formData.vatId" i18n-placeholder="@@societyVatIdPlaceholder" placeholder="e.g. DE123456789"></dx-text-box>
              </div>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <app-gpd-checkbox [(value)]="formData.vatLiable" i18n-label="@@societyVatLiable" label="Subject to VAT"></app-gpd-checkbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Side column: what the Gesellschaft is linked to. -->
        <div class="gpd-form-column gpd-form-column--side">
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="solar-panel" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societyPvProjects">PV Projects</span>
            </div>
            <div class="society-picker">
              <dx-tag-box
                class="gpd-input society-picker-box"
                applyValueMode="useButtons"
                [items]="projects"
                displayExpr="displayName"
                valueExpr="projectId"
                [(value)]="formData.projectIds"
                (onValueChanged)="updateListsScrollable()"
                [searchEnabled]="true"
                [showSelectionControls]="true"
                [showDropDownButton]="true"
              ></dx-tag-box>
              <span class="society-picker-placeholder" i18n="@@societySelectProjects">Assign projects</span>
            </div>
            <div class="society-linked-list" *ngIf="selectedProjects.length">
              <!-- Head row: count + search icon; the icon opens the search in its place. -->
              <div class="society-linked-head">
                @if (searchOpen.projects) {
                  <app-svg-icon icon="search" [size]="16" color="var(--color-primary)"></app-svg-icon>
                  <dx-text-box
                    class="society-linked-search"
                    [(value)]="searchTerm.projects"
                    valueChangeEvent="keyup"
                    i18n-placeholder="@@searchProject"
                    placeholder="Search project"
                    (onInitialized)="focusSoon($event)"
                  ></dx-text-box>
                  <span class="society-linked-hits" i18n="@@societyProjectsHits">{{ filteredProjects.length }} of {{ selectedProjects.length }}</span>
                  <app-gpd-button type="text" icon="cancel" i18n-hint="@@societyCloseSearch" hint="Close search" (onClick)="closeSearch('projects')"></app-gpd-button>
                } @else {
                  <span class="society-linked-count" i18n="@@societyProjectsCount">{{ selectedProjects.length }} Projects</span>
                  @if (scrollable.projects) {
                    <app-gpd-button type="text" icon="search" i18n-hint="@@societySearchProjects" hint="Search projects" (onClick)="searchOpen.projects = true"></app-gpd-button>
                  }
                }
              </div>
              <div #projectsListEl class="society-linked-rows">
                <div class="society-linked-row" *ngFor="let project of filteredProjects">
                  <app-contracts-pill
                    class="society-linked-name"
                    linkType="contractLinkName"
                    [content]="{ recordSource: 'project added', siteId: project.siteId, projectId: project.projectId, projectName: project.displayName }"
                    [projectStatus]="project.status"
                    [openInNewTab]="true"
                  ></app-contracts-pill>
                  <app-gpd-button
                    type="text"
                    icon="cancel"
                    i18n-hint="@@remove"
                    hint="Remove"
                    (onClick)="removeProject(project.projectId)"
                  ></app-gpd-button>
                </div>
                <p *ngIf="!filteredProjects.length" class="society-linked-empty" i18n="@@noProjectsMatchSearch">No projects match your search.</p>
              </div>
            </div>
            <!-- Standorte where the Gesellschaft owns Grundstücke, as on a contact's page; read-only. -->
            <div class="society-linked-list" *ngIf="ownedSites.length">
              <div class="society-linked-rows">
                <div class="society-linked-row" *ngFor="let site of ownedSites">
                  <app-contracts-pill
                    class="society-linked-name"
                    linkType="contractLinkName"
                    [content]="{ siteId: site.siteId, siteNr: site.siteNr, siteName: site.siteName }"
                    [openInNewTab]="true"
                  ></app-contracts-pill>
                  <span class="role-pill role-pill--source" [title]="site.role" (click)="openOwnedSiteProperties(site, $event)">
                    <span class="role-pill__text">{{ site.role }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="contracts" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@contractsCaps">Contracts</span>
            </div>

            <div class="society-upload">
              <div class="society-upload-header">
                <span class="gpd-form-label" i18n="@@societyArticlesOfAssociation">Articles of association</span>
                <!-- Once chosen or created, the contract takes the button's place. Same pill as
                     the contract documents; tracked by designation because the pill reads its
                     text only once and a just-created contract arrives with the list reload. -->
                @if (articlesContract; as contract) {
                  @for (pill of [contract]; track pill.designation) {
                    <app-contracts-pill
                      class="society-upload-header-pill"
                      linkType="contract"
                      [content]="{ contractId: pill.id, designation: pill.designation }"
                      icon="doc"
                      [editable]="true"
                      [openInNewTab]="true"
                      (onCloseClick)="clearArticlesContract()"
                    ></app-contracts-pill>
                  }
                } @else {
                  <ng-container *ngTemplateOutlet="createArticles"></ng-container>
                }
                <ng-template #createArticles>
                  <app-gpd-button
                    type="text"
                    icon="add"
                    i18n-text="@@societyAddContract"
                    text="Add contract"
                    (onClick)="articlesPopupVisible = true"
                  ></app-gpd-button>
                </ng-template>
              </div>
            </div>

            <div class="society-upload">
              <span class="gpd-form-label" i18n="@@societyOtherContracts">Further contracts</span>
              <div class="society-picker">
                <dx-tag-box
                  class="gpd-input society-picker-box"
                  applyValueMode="useButtons"
                  [items]="otherContracts"
                  displayExpr="designation"
                  valueExpr="id"
                  [(value)]="formData.contractIds"
                  (onValueChanged)="updateListsScrollable()"
                  [searchEnabled]="true"
                  [showSelectionControls]="true"
                  [showDropDownButton]="true"
                ></dx-tag-box>
                <span class="society-picker-placeholder" i18n="@@societySelectContracts">Assign contracts</span>
              </div>
              <div class="society-linked-list" *ngIf="selectedContracts.length">
                <!-- Head row: count + search icon; the icon opens the search in its place. -->
                <div class="society-linked-head">
                  @if (searchOpen.contracts) {
                    <app-svg-icon icon="search" [size]="16" color="var(--color-primary)"></app-svg-icon>
                    <dx-text-box
                      class="society-linked-search"
                      [(value)]="searchTerm.contracts"
                      valueChangeEvent="keyup"
                      i18n-placeholder="@@searchContract"
                      placeholder="Search contract"
                      (onInitialized)="focusSoon($event)"
                    ></dx-text-box>
                    <span class="society-linked-hits" i18n="@@societyContractsHits">{{ filteredContracts.length }} of {{ selectedContracts.length }}</span>
                    <app-gpd-button type="text" icon="cancel" i18n-hint="@@societyCloseSearch" hint="Close search" (onClick)="closeSearch('contracts')"></app-gpd-button>
                  } @else {
                    <span class="society-linked-count" i18n="@@societyContractsCount">{{ selectedContracts.length }} Contracts</span>
                    @if (scrollable.contracts) {
                      <app-gpd-button type="text" icon="search" i18n-hint="@@societySearchContracts" hint="Search contracts" (onClick)="searchOpen.contracts = true"></app-gpd-button>
                    }
                  }
                </div>
                <div #contractsListEl class="society-linked-rows">
                  <div class="society-linked-row" *ngFor="let contract of filteredContracts">
                    <app-contracts-pill
                      class="society-linked-name"
                      linkType="contract"
                      [content]="{ contractId: contract.id, designation: contract.designation }"
                      [openInNewTab]="true"
                    ></app-contracts-pill>
                    <app-gpd-button
                      type="text"
                      icon="cancel"
                      i18n-hint="@@remove"
                      hint="Remove"
                      (onClick)="removeContract(contract.id)"
                    ></app-gpd-button>
                  </div>
                  <p *ngIf="!filteredContracts.length" class="society-linked-empty" i18n="@@noContractsMatchSearch">No contracts match your search.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="files" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@societyDocuments">Documents</span>
              <span class="society-doc-total">{{ documentTotalText }}</span>
            </div>

            <!-- Grouped by topic, collapsible; each header shows how many of its document types are there. -->
            <div class="society-doc-groups">
              <div class="society-doc-group" *ngFor="let group of documentGroups">
                <button type="button" class="society-doc-group-head" [attr.aria-expanded]="isGroupOpen(group)" (click)="toggleGroup(group)">
                  <app-svg-icon
                    class="society-doc-group-chevron"
                    [class.society-doc-group-chevron--closed]="!isGroupOpen(group)"
                    icon="chevron-down"
                    [size]="16"
                    color="var(--color-grey-600)"
                  ></app-svg-icon>
                  <span class="society-doc-group-title">{{ group.label }}</span>
                  <span class="society-doc-group-bar" aria-hidden="true">
                    <span [style.width.%]="(groupProgress(group) / group.sections.length) * 100"></span>
                  </span>
                  <span class="society-doc-group-progress" [class.society-doc-group-progress--full]="groupProgress(group) === group.sections.length">
                    {{ groupProgress(group) }}/{{ group.sections.length }}
                  </span>
                </button>

                <div class="society-doc-group-body" *ngIf="isGroupOpen(group)">
                  <div class="society-doc-row" *ngFor="let section of group.sections">
                    <div class="society-doc-row-line">
                      <span class="society-doc-row-name">{{ section.label }}</span>
                      <app-gpd-button
                        *ngIf="!section.single || !documentsOf(section.kind).length"
                        type="text"
                        icon="upload"
                        [hint]="section.single ? selectFileHint : selectFilesHint"
                        (onClick)="fileInput.click()"
                      ></app-gpd-button>
                      <input #fileInput type="file" hidden [multiple]="!section.single" (change)="addFiles(section.kind, fileInput)" />
                    </div>
                    <div class="society-file-pills" *ngIf="documentsOf(section.kind).length">
                      <gpd-pill
                        *ngFor="let file of documentsOf(section.kind)"
                        [text]="file.name"
                        icon="document"
                        [clickable]="true"
                        [removable]="true"
                        maxWidth="100%"
                        backgroundColor="var(--color-white)"
                        color="var(--color-primary)"
                        (onClick)="openFile(file)"
                        (onRemove)="removeFile(file)"
                      ></gpd-pill>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dx-validation-group>
  </div>

  <app-form-footer>
    <app-gpd-button footerRight i18n-text="@@cancel" text="ABORT" type="secondary" icon="cancel" (onClick)="handleAbort()"></app-gpd-button>
    <app-gpd-button footerRight i18n-text="@@save" text="CONFIRM" type="primary" icon="check" iconColor="white" (onClick)="handleSubmit()"></app-gpd-button>
  </app-form-footer>

  <app-validation-toast #validationToast></app-validation-toast>
</div>

<!-- Same contract popup as on tasks; a new contract gets the type Gesellschaftsvertrag. -->
<app-contract-selector-popup
  [visible]="articlesPopupVisible"
  [preset]="articlesPreset"
  (hidden)="articlesPopupVisible = false"
  (contractSelected)="onArticlesContractSelected($event)"
  (addingContract)="onAddingArticlesContract()"
></app-contract-selector-popup>

<app-contacts-popup
  class="dx-treevieweditor-overlay"
  [(visible)]="contactsPopupVisible"
  (onHiding)="contactsPopupVisible = false"
  [(companies)]="companies"
  [(persons)]="persons"
  (onContactSelected)="onPopupContactSelected($event)"
  (onContactAdded)="onPopupContactSelected($event)"
></app-contacts-popup>

